import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-sortdirection',
  templateUrl: './sortdirection.component.html',
  styleUrl: './sortdirection.component.css'
})
export class SortdirectionComponent {
  @Input() property: string = ''
  @Input() direction: string = ''

}

